// extracted by mini-css-extract-plugin
export default {"pageRoot":"ArchitectsAndPlanningConsultancyPage_pageRoot__FvdZn","pageContent":"ArchitectsAndPlanningConsultancyPage_pageContent__D1n6e"};